import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import { orderInsure, orderInsureData } from '../../../../helpers/restHelpers'
import Alert from '@material-ui/lab/Alert'
import TextField from '@material-ui/core/TextField/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { MoneyNumberFormat } from '../../../../utils/formaters'

const initialState = {
    open: false,
    loading: false,
    orderInfo: null,
    itemsTotalAmount: false,
    errorValue: '',
}

class Component extends React.Component {
    state = { ...initialState }

    handleClickOpen = () => {
        this.setState({ ...initialState, open: true, loading: true })

        orderInsureData(this.props.orderId)
            .then((x) => this.setState({ loading: false, orderInfo: x }))
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ ...initialState })
    }

    confirm = () => {
        const data = {
            orderId: this.props.orderId,
            insuredValue: this.state.orderInfo.insuredValue,
            itemsTotalAmount: this.state.itemsTotalAmount,
        }

        this.setState({ loading: true, open: false })
        orderInsure(data)
            .then(() => {
                this.handleClose(true)
                window.showDialog(
                    {
                        title: strings.orderInsureSuccessTitle,
                        message: strings.orderInsureSuccess,
                    },
                    () => this.props.actionDone()
                )
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    changeInsuredValue = (value) => {
        const { orderInfo } = this.state
        let errorValue = ''
        if (value > orderInfo.maximumInsurableValue)
            errorValue = strings.orderInsureIsMaximum
        if (value > orderInfo.itemsTotalAmountValue)
            errorValue = strings.orderInsureExceedsItemsValue
        if (isNaN(parseFloat(value))) errorValue = strings.orderInsureIsNaNValue

        this.setState({
            errorValue: errorValue,
            orderInfo: { ...orderInfo, insuredValue: value },
        })
    }

    changeCheckValue = (checked) => {
        const { orderInfo } = this.state
        this.setState({
            itemsTotalAmount: checked,
            orderInfo: {
                ...orderInfo,
                insuredValue: orderInfo.itemsTotalAmountValue,
            },
        })
    }

    calcPrime = (orderInfo) => {
        let { insuredValue, minimumInsurableValue, premiumRate } = orderInfo
        insuredValue = parseFloat(insuredValue)
        return insuredValue === 0
            ? 0
            : insuredValue < minimumInsurableValue
            ? ((minimumInsurableValue * premiumRate) / 100).toFixed(2)
            : ((insuredValue * premiumRate) / 100).toFixed(2)
    }

    render() {
        const { orderInfo } = this.state

        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.orderInsureButton}
                </div>
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.orderInsureDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        {!orderInfo ? null : (
                            <div>
                                <div style={{ textAlign: 'center' }}>
                                    <TextField
                                        label={
                                            strings.orderInsureInsuredValueLabel
                                        }
                                        value={
                                            this.state.orderInfo.insuredValue
                                        }
                                        onChange={(x) =>
                                            this.changeInsuredValue(
                                                x.target.value
                                            )
                                        }
                                        error={!!this.state.errorValue.length}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            maxLength: 20,
                                            inputComponent: MoneyNumberFormat,
                                        }}
                                        disabled={this.state.itemsTotalAmount}
                                    />

                                    <TextField
                                        label={
                                            strings.orderInsureInsuredPrimeLabel
                                        }
                                        value={'$' + this.calcPrime(orderInfo)}
                                        inputProps={{ readOnly: true }}
                                    />
                                </div>

                                {!this.state.errorValue.length ? null : (
                                    <Alert
                                        severity="error"
                                        style={{ whiteSpace: 'pre-line' }}
                                    >
                                        {this.state.errorValue}
                                    </Alert>
                                )}

                                {!orderInfo.itemsTotalAmountValue ? null : (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    this.state.itemsTotalAmount
                                                }
                                                onChange={(x) =>
                                                    this.changeCheckValue(
                                                        x.target.checked
                                                    )
                                                }
                                                name="checkedB"
                                                color="primary"
                                                disabled={
                                                    orderInfo.itemsTotalAmountValue >
                                                    orderInfo.maximumInsurableValue
                                                }
                                            />
                                        }
                                        label={strings.orderInsureItemsAmountLabel.replace(
                                            '{{value}}',
                                            orderInfo.itemsTotalAmountValue.toFixed(
                                                2
                                            )
                                        )}
                                    />
                                )}
                                <div
                                    style={{
                                        fontSize: '75%',
                                        backgroundColor: 'lightgoldenrodyellow',
                                        padding: 10,
                                        marginTop: 18,
                                        whiteSpace: 'pre-line',
                                    }}
                                >
                                    {strings.orderInsureInfo
                                        .replace(
                                            '{{minimum}}',
                                            orderInfo.minimumInsurableValue.toFixed(
                                                2
                                            )
                                        )
                                        .replace(
                                            '{{maximum}}',
                                            orderInfo.maximumInsurableValue.toFixed(
                                                2
                                            )
                                        )
                                        .replace(
                                            '{{premium}}',
                                            orderInfo.premiumRate
                                        )}
                                </div>
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                            disabled={
                                this.state.loading ||
                                !!this.state.errorValue.length
                            }
                        >
                            {strings.continue}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

export default Component
